import React from "react"
import { Link, Image } from "@chakra-ui/react"
import { getGoogleWalletBadge, getGoogleWalletPassUrl } from "utilities/walletPass"

type Props = {
  guestExternalId: string
  language: string
}

const AddToGoogleWallet = ({ guestExternalId, language }: Props) => (
  <Link isExternal href={getGoogleWalletPassUrl(guestExternalId)}>
    <Image
      {...getGoogleWalletBadge(language)}
      alt="Add to Google Wallet"
      height={41}
    />
  </Link>
)

export default AddToGoogleWallet
